







import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "DeleteFooterButton",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
});
